<template>
  <div>
    <Card title="Artist Onboarding">
      <template v-slot:body>
        <div>
          <div class="pb-6 flex justify-between items-center">
            <div class="flex items-center">
              <div class="mr-2">
                <el-input placeholder="search name or email" v-model="filter" @change="search"></el-input>
              </div>
              <div class="mr-2">
                <el-select v-model="statusFilter" filterable placeholder="Select Status" @change="search">
                  <el-option value="" label="All"></el-option>
                  <el-option value="IN_REVIEW" label="In Review"></el-option>
                  <el-option value="APPROVED" label="Approved"></el-option>
                  <el-option value="REJECTED" label="Rejected"></el-option>
                </el-select>
              </div>
              <Button @clicked="search" label="Apply"/>
              <button class="p-2"><font-awesome-icon :icon="['fas', 'sync']" @click="reset" /></button>
            </div>
          </div>
        </div>
        <data-tables-server ref="tableApplication" :data="data" :total="total" :pagination-props="{ background: true,pageSizes: [20,50,100,300,500] }" @query-change="onChangeTable">
          <el-table-column v-for="title in titles" :prop="title.prop.field" :label="title.label" :key="title.prop.field" sortable="custom" :width="title.prop.width">
          </el-table-column>
          <el-table-column label="Status" min-width="140px">
            <template slot-scope="scope">
              <span :class="statusBadgeClass(scope.row.status)">{{ statusLabel(scope.row.status) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="isSuperAdmin || isAdmin || isOps || isRecruitment" label="Actions" align="right" min-width="220px">
            <template slot-scope="scope">
              <div class="static inline-block text-left container-action">
                <VueCustomTooltip label="Detail" :position="'is-left'">
                  <a :href="`/#/artists/onboarding/${scope.row.id}`" class="inline-block p-2 w-8 mr-2 rounded bg-blue-500 hover:bg-blue-600 focus:outline-none">
                    <font-awesome-icon class="text-white" :icon="['fa', 'eye']" />
                  </a>
                </VueCustomTooltip>
                <VueCustomTooltip v-if="scope.row.status === 'IN_REVIEW'" label="Approve" :position="'is-left'">
                  <a @click="approve(scope.row)" class="inline-block p-2 w-8 mr-2 rounded bg-green-500 hover:bg-green-600 focus:outline-none">
                    <font-awesome-icon class="text-white" :icon="['fa', 'check']" />
                  </a>
                </VueCustomTooltip>
                <VueCustomTooltip v-if="scope.row.status === 'IN_REVIEW'" label="Reject" :position="'is-left'">
                  <a @click="openReject(scope.row)" class="inline-block p-2 w-8 mr-2 rounded bg-red-500 hover:bg-red-600 focus:outline-none">
                    <font-awesome-icon class="text-white" :icon="['fa', 'times']" />
                  </a>
                </VueCustomTooltip>
              </div>
            </template>
          </el-table-column>
        </data-tables-server>
      </template>
    </Card>
    <ModalDialog
      ref="rejectionModal"
      :isShowingModal="isShowingModalReject"
      :isLoading="isLoading"
      :error="isError"
      labelSubmit="Submit Rejection"
      title="Reject Application"
      @toggleModal="isShowingModalReject = !isShowingModalReject"
      @save="submitRejected()"
    >
      <template slot="body">
        <RejectionForm ref="rejectionForm" :toggle-reset="isShowingModalReject" :song-rejection="rejectionTarget" :custom-submit="customReject" @on-submit-rejection="onSubmitRejectionForm">
        </RejectionForm>
      </template>
    </ModalDialog>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import Card from '@/components/Layout/Card.vue';
import { Button } from '@/components/Layout/Form';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';
import ModalDialog from '../../components/Common/ModalDialog';
import RejectionForm from '../contents/RejectionForm';

const limit = 20;
export default {
  name: 'ArtistOnboarding',
  data() {
    return {
      isError: false,
      isShowingModalReject: false,
      data: [],
      total: 0,
      page: 1,
      filter: '',
      statusFilter: 'IN_REVIEW',
      rejectionTarget: { id: '' },
      titles: [{
        prop: {
          field: 'first_name',
        },
        label: 'First Name',
      }, {
        prop: {
          field: 'last_name',
        },
        label: 'Last Name',
      }, {
        prop: {
          field: 'email',
        },
        label: 'Email',
      }, {
        prop: {
          field: 'submitted_at',
        },
        label: 'Submitted',
      }],
      filterParam: {
        per_page: limit,
        q: '',
        status: 'IN_REVIEW',
      },
    };
  },
  async mounted() {
    await this.requestListArtistApplication(this.filterParam);
  },
  computed: {
    ...mapGetters('NotificationModule', ['isLoading']),
    ...mapGetters('AuthModule', ['isSuperAdmin', 'isAdmin', 'isFinance', 'isOps', 'isRecruitment']),
    ...mapGetters('ArtistModule', ['listArtistApplication']),
  },
  watch: {
    listArtistApplication: {
      immediate: true,
      async handler() {
        await this.refineData();
      },
    },
  },
  methods: {
    ...mapActions('ArtistModule', ['requestListArtistApplication', 'requestApproveArtistApplication', 'requestRejectArtistApplication']),
    async search() {
      this.filterParam.q = this.filter;
      this.filterParam.status = this.statusFilter;
      await this.requestListArtistApplication(this.filterParam);
    },
    async reset() {
      this.$refs.tableApplication.$refs.elTable.clearSort();
      this.filter = '';
      this.statusFilter = 'IN_REVIEW';
      this.filterParam.q = '';
      this.filterParam.status = 'IN_REVIEW';
      await this.requestListArtistApplication(this.filterParam);
    },
    refineData() {
      if (this.listArtistApplication.data !== undefined) {
        this.total = this.listArtistApplication.data.total;
        this.data = this.listArtistApplication.data.data;
      }
    },
    async onChangeTable(queryInfo) {
      if (queryInfo.type === 'init') return;
      const pageSize = queryInfo.pageSize;
      this.displayingItem = pageSize;
      const page = queryInfo.page;
      this.page = page;
      let sortby = queryInfo.sort.prop;
      let sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      if (typeof (sortby) === 'undefined') {
        sortby = 'id';
      }
      sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      this.filterParam = { ...this.filterParam, per_page: this.displayingItem, q: this.filter, status: this.statusFilter, sortorder, sortby, page };
      await this.requestListArtistApplication(this.filterParam);
    },
    statusLabel(status) {
      switch (status) {
        case 'APPROVED':
          return 'Approved';
        case 'REJECTED':
          return 'Rejected';
        case 'IN_REVIEW':
        default:
          return 'In Review';
      }
    },
    statusBadgeClass(status) {
      const base = 'inline-block px-3 py-1 rounded-full text-xs font-bold ';
      switch (status) {
        case 'APPROVED':
          return `${base}bg-green-100 text-green-700`;
        case 'REJECTED':
          return `${base}bg-red-100 text-red-700`;
        case 'IN_REVIEW':
        default:
          return `${base}bg-yellow-100 text-yellow-700`;
      }
    },
    async approve(row) {
      Vue.swal({
        title: 'Approve Application',
        text: `Are you sure to approve artist application: ${row.first_name} ${row.last_name}`,
        icon: 'warning',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true,
      }).then(async (result) => {
        if (result.value) {
          const data = { id: row.id };
          const filter = this.filterParam;
          await this.requestApproveArtistApplication({ data, filter });
          this.$swal('Approved', `You successfully approve artist application: ${row.first_name} ${row.last_name}`, 'success');
        }
      });
    },
    openReject(row) {
      this.rejectionTarget = { id: row.id };
      this.isShowingModalReject = true;
    },
    async submitRejected() {
      await this.$refs.rejectionForm.submitRejection();
    },
    async customReject({ id, note }) {
      const data = { id, rejection_reason: note };
      const filter = this.filterParam;
      await this.requestRejectArtistApplication({ data, filter });
    },
    onSubmitRejectionForm() {
      this.isShowingModalReject = false;
      this.rejectionTarget = { id: '' };
    },
  },
  components: { ModalDialog, RejectionForm, Card, Button, VueCustomTooltip },
};
</script>

<style scoped>
.el-table {
  min-height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/ArtistContent/ArtistOnboarding.vue